import * as Website from '../Config/Website.js';

const update = () => {
  // iOS判定
  if ( Website.status.ua.indexOf('ipad') > -1 ||
      Website.status.ua.indexOf('iphone') > -1 ||
      (Website.status.ua.indexOf('macintosh') > -1 && 'ontouchend' in document )
  ) {
    document.body.classList.add(Website.classList.ios);
    Website.status.isIos = true;
  } else {
    document.body.classList.remove(Website.classList.ios);
    Website.status.isIos = false;
  }

  // Windows判定
  if (Website.status.ua.indexOf('windows') > -1) {
    document.body.classList.add(Website.classList.windows);
    Website.status.isWindows = true;
  } else {
    document.body.classList.remove(Website.classList.windows);
    Website.status.isWindows = false;
  }

  // Mac判定（オプション）
  if (Website.status.ua.indexOf('macintosh') > -1 || Website.status.ua.indexOf('mac os') > -1) {
    document.body.classList.add(Website.classList.mac);
    Website.status.isMac = true;
  } else {
    document.body.classList.remove(Website.classList.mac);
    Website.status.isMac = false;
  }

  // タッチデバイス判定
  if('ontouchstart' in window || navigator.maxTouchPoints) {
    document.body.classList.add(Website.classList.touch);
    Website.status.isTouch = true;
  } else {
    document.body.classList.remove(Website.classList.touch);
    Website.status.isTouch = false;
  }

  // デバイス種類判定
  if (
    Website.status.ua.indexOf('iphone') > -1 ||
    Website.status.ua.indexOf('ipod') > -1 ||
    Website.status.ua.indexOf('android') > -1 && Website.status.ua.indexOf('mobile') > -1
  ) {
    // スマホ
    Website.status.isDesktop = false;
    Website.status.isTablet = false;
    Website.status.isMobile = true;
    document.body.classList.remove(Website.classList.tb, Website.classList.pc);
    document.body.classList.add(Website.classList.sp);
  } else if (
    Website.status.ua.indexOf('ipad') > -1 ||
    Website.status.ua.indexOf('Android') > -1 ||
    (Website.status.ua.indexOf('macintosh') > -1 && 'ontouchend' in document )
  ) {
    // タブレット
    Website.status.isDesktop = false;
    Website.status.isTablet = true;
    Website.status.isMobile = false;
    document.body.classList.remove(Website.classList.pc, Website.classList.sp);
    document.body.classList.add(Website.classList.tb);
    if( Website.status.tabletView !== false && typeof Website.status.tabletView === 'number' ){
      document.querySelector('meta[name="viewport"]').setAttribute('content', `width=${Website.status.tabletView}, initial-scale=1, maximum-scale=2, user-scalable=yes`);
    }
  } else {
    // PC
    Website.status.isDesktop = true;
    Website.status.isTablet = false;
    Website.status.isMobile = false;
    document.body.classList.remove(Website.classList.tb, Website.classList.sp);
    document.body.classList.add(Website.classList.pc);
  }
}

export default update;